export default "data:image/gif;base64,R0lGODlhEgAMAPAAAH7A7v//ACH5BAAAAAAALAAAAAASAAwAAAIchB15y5fRIlKyvWqpfLz7D16LiDlaCZCoWrJMAQA7"